import { requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { missionEntityName } from '../mission';
import { getAuthorizedMissionTypesFilter } from '../shift';
export function getMissionsManageFilter(userState) {
    if (requireAnySystemPermission(userState, 'manage-missions')) {
        return [];
    }
    if (requireAnySystemPermission(userState, 'manage-all-admin-missions')) {
        return getAuthorizedMissionTypesFilter(userState);
    }
    return null;
}
export function getShiftsManageFilter(userState) {
    const hasManageMissionPermission = requireAnySystemPermission(userState, 'manage-missions');
    const filter = [];
    if (!hasManageMissionPermission) {
        filter.push({
            column: 'missionId',
            op: 'in',
            subFilter: {
                entity: missionEntityName,
                filter: getAuthorizedMissionTypesFilter(userState),
            },
        });
    }
    return filter;
}
